var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup35792(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35792",
    transform: "translate(-677 -1498)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 346",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(677 1498)",
    style: {
      opacity: 0.2,
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34628"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41398",
    d: "M-788.824-3753.905c-.055.06-.111.125-.171.185a1.486 1.486 0 0 1-2.461-.546.373.373 0 0 0-.366-.285 1.987 1.987 0 0 1-1.682-1.5.4.4 0 0 0-.208-.256 1.992 1.992 0 0 1-1.383-2.851 1.253 1.253 0 0 0 .035-.122 2.033 2.033 0 0 1-.97-1.463 1.906 1.906 0 0 1 .65-1.759.345.345 0 0 0 .121-.376 1.962 1.962 0 0 1 1.668-2.357.387.387 0 0 0 .378-.334 1.955 1.955 0 0 1 1.473-1.4.379.379 0 0 0 .231-.2 1.5 1.5 0 0 1 2.611-.541.485.485 0 0 1 .054.124c.1-.1.147-.16.2-.214a1.485 1.485 0 0 1 2.48.529.372.372 0 0 0 .368.282 1.988 1.988 0 0 1 1.68 1.5.4.4 0 0 0 .21.254 1.993 1.993 0 0 1 1.4 2.826c-.018.043-.032.088-.052.144a2.037 2.037 0 0 1 .965 1.407 2 2 0 0 1-.631 1.828.451.451 0 0 0-.129.333 1.988 1.988 0 0 1-1.727 2.4.3.3 0 0 0-.3.262 1.969 1.969 0 0 1-1.49 1.457c-.086.023-.208.1-.226.168a1.506 1.506 0 0 1-2.656.53c-.018-.006-.04-.01-.072-.025zm-4.194-2.382a1.4 1.4 0 0 0 1.41 1.233l.609-.968.326.432c-.031.043-.045.069-.064.09a1.015 1.015 0 0 0-.164 1.258 1.01 1.01 0 0 0 1.1.43 1.025 1.025 0 0 0 .747-1.033v-.4h.5c-.046.622.024 1.176.686 1.417a.964.964 0 0 0 1.08-.32 1.027 1.027 0 0 0-.091-1.383l.351-.392.5.866a1.408 1.408 0 0 0 1.139-1.022 1.509 1.509 0 0 0-.626-1.73l.281-.457a5.728 5.728 0 0 1 .6.678 5.374 5.374 0 0 1 .351.793 1.415 1.415 0 0 0 1.386-1.811l-.643.086v-.48c.125-.025.232-.041.335-.068a1.429 1.429 0 0 0 1.1-1.131 1.465 1.465 0 0 0-.508-1.473.322.322 0 0 0-.5-.015 1.846 1.846 0 0 1-2.041.195l.185-.395a1.561 1.561 0 0 0 1.793-.418 1.415 1.415 0 0 0 .22-1.563 1.524 1.524 0 0 0-1.8-.858l-.129-.443.266-.084a1.391 1.391 0 0 0-1.4-1.233l-.612.969-.32-.424a.563.563 0 0 1 .05-.085 1.021 1.021 0 0 0 .167-1.282 1.012 1.012 0 0 0-1.1-.414 1.036 1.036 0 0 0-.733 1.073v.363h-.5c.047-.637-.031-1.211-.731-1.435a.956.956 0 0 0-1.082.391 1.019 1.019 0 0 0 .138 1.32l-.359.4-.495-.87a1.4 1.4 0 0 0-1.119.954 1.517 1.517 0 0 0 .606 1.806l-.257.4a2.049 2.049 0 0 1-.938-1.413 1.426 1.426 0 0 0-1.439 1.8l.661-.084v.476l-.268.058a1.483 1.483 0 0 0-.911 2.35c.309.429.443.457.87.185a1.436 1.436 0 0 1 .125-.075 1.962 1.962 0 0 1 1.8-.043l-.2.427a1.493 1.493 0 0 0-1.814.444 1.394 1.394 0 0 0-.165 1.594 1.522 1.522 0 0 0 1.765.788l.131.453z",
    transform: "translate(1480.811 5273.771)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41399",
    d: "M-741.008-3757.531c-.415.07-.4.064-.528-.318a2.037 2.037 0 0 0-1.664-1.422v-.455a2.347 2.347 0 0 1 2.192 2.195z",
    transform: "translate(1440.477 5267.254)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41400",
    d: "M-797.051-3722.882c.425-.058.409-.052.541.329a2.029 2.029 0 0 0 1.664 1.413v.441a2.335 2.335 0 0 1-2.205-2.183z",
    transform: "translate(1481.574 5239.156)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41401",
    d: "M-735.97-3748.191h.49v.479h-.468z",
    transform: "translate(1434.96 5258.45)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41402",
    d: "M-796.6-3726.6h-.464v-.479h.464z",
    transform: "translate(1481.584 5242.339)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41403",
    d: "M-777.985-3747.888a.759.759 0 0 1 .209-1.15.537.537 0 0 0-.046-.73 3.172 3.172 0 0 1-1.321-2.869 3.244 3.244 0 0 1 3.026-3 3.236 3.236 0 0 1 3.365 2.539 3.161 3.161 0 0 1-1.23 3.313.5.5 0 0 0 .008.793.769.769 0 0 1 .138 1.094.794.794 0 0 1-.762 1.27c-.886-.04-1.775-.008-2.662-.01-.779-.001-1.111-.562-.725-1.25zm3.315-1.272a3.65 3.65 0 0 0 0-.388.558.558 0 0 1 .295-.578 2.708 2.708 0 0 0 1.106-3 2.736 2.736 0 0 0-2.413-1.994 2.748 2.748 0 0 0-2.783 1.728 2.642 2.642 0 0 0 .8 3.089 1.074 1.074 0 0 1 .522 1.088c0 .014.017.031.027.049h.96c0-.433.007-.842-.006-1.251a.415.415 0 0 0-.129-.243c-.26-.263-.531-.515-.794-.767l.392-.436.812.93.793-.868.365.345c-.279.274-.538.525-.792.781-.059.06-.138.138-.14.209-.013.435-.007.871-.007 1.308zm-1.241 2.014h1.375c.179 0 .356-.019.361-.24s-.168-.25-.35-.25h-2.779c-.183 0-.351.032-.346.254 0 .2.163.237.336.236.467-.003.935-.001 1.403 0zm-.026-1h1.4c.18 0 .355-.022.358-.243s-.173-.248-.353-.248h-2.779c-.183 0-.351.035-.343.257.007.2.166.235.338.233.462-.001.916.002 1.378.002z",
    transform: "translate(1467.914 5264.139)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41404",
    d: "M-774.38-3748.64h-.44a2.088 2.088 0 0 1 1.444-2.081c.03.065.064.131.091.2s.048.146.077.237a1.828 1.828 0 0 0-1.172 1.644z",
    transform: "translate(1464.618 5260.381)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41405",
    d: "M-766.5-3751.313h.48l-.041.478h-.392z",
    transform: "translate(1458.258 5260.833)",
    style: {
      fill: "#5f7d95"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup35792);
export default __webpack_public_path__ + "static/media/Group35792.ed7603f9abdf8dc783703dc4b2fe7fe6.svg";
export { ForwardRef as ReactComponent };